import { render, staticRenderFns } from "./QuestionRectMult.vue?vue&type=template&id=ed56d2b4&scoped=true&"
import script from "./QuestionRectMult.vue?vue&type=script&lang=js&"
export * from "./QuestionRectMult.vue?vue&type=script&lang=js&"
import style0 from "./QuestionRectMult.vue?vue&type=style&index=0&id=ed56d2b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed56d2b4",
  null
  
)

export default component.exports